{
  "title": "Benarkan akses ke lokasi anda?",
  "body": "Dengan membenarkan akses ke lokasi anda, kami dapat memastikan anda telah tiba di kemudahan untuk daftar masuk",
  "disagree": "Tidak Setuju",
  "agree": "Setuju"
}
